/**
 * assets/schema-cleanup.js
 * Gedrag van snippets/schema-cleanup.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function() {
  'use strict';

  function cleanupInvalidProductSchema() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    scripts.forEach(function(script) {
      try {
        var data = JSON.parse(script.textContent);

        /* Skip onze eigen @graph-based Product schema (heeft altijd offers)*/
        if (data['@graph']) return;

        /* Check top-level Product entities*/
        if (data['@type'] === 'Product') {
          if (!data.offers && !data.review && !data.aggregateRating) {
            script.remove();
          }
        }
      } catch(e) {
        /* Ongeldige JSON, negeren*/
      }
    });
  }


  /* Hub-template pages: verwijder door apps geinjecteerde WebPage duplicates*/
  /* (meta-tags.liquid emit geen WebPage op hub-templates, dus elke WebPage is duplicate).*/
  function cleanupDuplicateWebPageOnHub() {
    var body = document.body;
    if (!body) return;
    if (body.getAttribute('data-template-suffix') !== 'hub') return;

    var seen = false;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function(script) {
      try {
        var data = JSON.parse(script.textContent);
        var nodes = data['@graph'] ? data['@graph'] : [data];
        var hasWebPage = nodes.some(function(n) { return n && n['@type'] === 'WebPage'; });
        if (!hasWebPage) return;
        if (!seen) { seen = true; return; } /* eerste houden (eigen Article/Hub schema bevat soms WebPage-achtige ref)*/
        script.remove();
      } catch(e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupDuplicateWebPageOnHub);
  } else {
    cleanupDuplicateWebPageOnHub();
  }

  /* Run direct en na korte delay (voor dynamisch geïnjecteerde schema)*/
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupInvalidProductSchema);
  } else {
    cleanupInvalidProductSchema();
  }

  /* MutationObserver voor schema die later wordt geïnjecteerd door apps*/
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.tagName === 'SCRIPT' && node.type === 'application/ld+json') {
          try {
            var data = JSON.parse(node.textContent);
            if (data['@type'] === 'Product' && !data['@graph'] && !data.offers && !data.review && !data.aggregateRating) {
              node.remove();
              return;
            }
            /* Hub duplicate WebPage*/
            if (document.body && document.body.getAttribute('data-template-suffix') === 'hub') {
              var nodes = data['@graph'] ? data['@graph'] : [data];
              var hasWebPage = nodes.some(function(n) { return n && n['@type'] === 'WebPage'; });
              if (hasWebPage) {
                var count = 0;
                document.querySelectorAll('script[type="application/ld+json"]').forEach(function(s2) {
                  try {
                    var d2 = JSON.parse(s2.textContent);
                    var ns = d2['@graph'] ? d2['@graph'] : [d2];
                    if (ns.some(function(n) { return n && n['@type'] === 'WebPage'; })) count++;
                  } catch(e) {}
                });
                if (count > 1) node.remove();
              }
            }
          } catch(e) {}
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Stop observer na 30 seconden (performance)*/
  setTimeout(function() { observer.disconnect(); }, 30000);
})();
